import apiClient from '../../../Api/axiosConfig';
import { components } from '../../../Api/types/openapi';

type LegalConsulationResponse = components['schemas']['LegalConsulationResponse'];
type PaginationLegalConsulationResponse = components['schemas']['Pagination_LegalConsulationResponse_'];
type PaginationLegalConsulationForLawyerResponse = components['schemas']['Pagination_LegalConsulationForLawyerResponse_'];
type PaginationLegalConsulationForClientResponse = components['schemas']['Pagination_LegalConsulationForClientResponse_'];
type BodyCreateLegalConsulation = components['schemas']['Body_create_legal_consulation_api_core_legal_consulations__post'];
type AssignToLawyerSerializer = components['schemas']['AssignToLawyerSerializer'];
type RescheduleLegalConsulation = components['schemas']['RescheduleLegalConsulation'];
type LegalConsulationForClientResponse = components['schemas']['LegalConsulationForClientResponse'];

const getAppointments = async (params?: {
  time_zone?: string;
  consultation_date?: string | null;
  init_consultation_time?: string | null;
  end_consultation_time?: string | null;
  description?: string;
  status?: string;
  status_payment?: string;
  client?: number;
  lawyer?: number;
  page?: number;
  limit?: number;
  role?: 'admin' | 'lawyer' | 'client';
}): Promise<PaginationLegalConsulationResponse | PaginationLegalConsulationForLawyerResponse | PaginationLegalConsulationForClientResponse> => {
  let endpoint = '/core/legal-consulations/admin';
  
  if (params?.role === 'lawyer') {
    endpoint = '/core/legal-consulations/lawyer';
  } else if (params?.role === 'client') {
    endpoint = '/core/legal-consulations/client';
  }
  
  const { role, ...queryParams } = params || {};
  const response = await apiClient.get(endpoint, { params: queryParams });
  return response.data;
};

const getAppointmentById = async (pk: number): Promise<LegalConsulationResponse> => {
  const response = await apiClient.get<LegalConsulationResponse>(`/core/legal-consulations/${pk}`);
  return response.data;
};

const createAppointment = async (body: BodyCreateLegalConsulation): Promise<LegalConsulationResponse> => {
  const formData = new FormData();
  formData.append('time_zone', body.time_zone);
  formData.append('consultation_date', body.consultation_date);
  formData.append('init_consultation_time', body.init_consultation_time);
  formData.append('end_consultation_time', body.end_consultation_time);
  formData.append('description', body.description || '');
  if (body.files) {
    body.files.forEach((file) => formData.append('files', file));
  }
  if (body.document_ai) formData.append('document_ai', body.document_ai);
  
  // IMPORTANTE: NO establecer Content-Type manualmente para FormData
  // El navegador lo establecerá automáticamente con el boundary correcto
  const response = await apiClient.post<LegalConsulationResponse>('/core/legal-consulations/', formData);
  return response.data;
};

const assignLawyer = async (body: AssignToLawyerSerializer): Promise<LegalConsulationForClientResponse> => {
  const response = await apiClient.post<LegalConsulationForClientResponse>('/core/legal-consulations/assign-to-lawyer', body);
  return response.data;
};

const rescheduleAppointment = async (body: RescheduleLegalConsulation): Promise<LegalConsulationForClientResponse> => {
  const response = await apiClient.put<LegalConsulationForClientResponse>('/core/legal-consulations/reschedule', body);
  return response.data;
};

const addDocument = async (pk: number, file: File, typeFile: string): Promise<LegalConsulationResponse> => {
  const formData = new FormData();
  // IMPORTANTE: Según OpenAPI, tanto 'file' como 'type_file' van en el body del FormData
  formData.append('file', file, file.name);
  formData.append('type_file', typeFile);
  // IMPORTANTE: NO establecer Content-Type manualmente para FormData
  // El navegador lo establecerá automáticamente con el boundary correcto
  const response = await apiClient.post<LegalConsulationResponse>(
    `/core/legal-consulations/add-document/${pk}`,
    formData
    // type_file ahora va en el FormData, no como query parameter
  );
  return response.data;
};

const deleteDocument = async (pk: number, file: number): Promise<LegalConsulationResponse> => {
  const response = await apiClient.delete<LegalConsulationResponse>(`/core/legal-consulations/delete-document/${pk}/${file}`);
  return response.data;
};

export default {
  getAppointments,
  getAppointmentById,
  createAppointment,
  assignLawyer,
  rescheduleAppointment,
  addDocument,
  deleteDocument,
};

